import http from './api'

const route = 'app/fluxovenda/'

export default {
  showFaturamentoClienteProduto: (dataInicial2, dataFinal2, empresas, cidades, areas, vendedores, redes, clientes, produtos, tokenContrato, dataInicial1, dataFinal1, segmento) => {
    return http.post(route + 'showFaturamentoClienteProduto', {
      dataInicial2: dataInicial2,
      dataFinal2: dataFinal2,
      empresas: empresas,
      cidades: cidades,
      areas: areas,
      vendedores: vendedores,
      redes: redes,
      clientes: clientes,
      produtos: produtos,
      tokenContrato: tokenContrato,
      dataInicial1: dataInicial1,
      dataFinal1: dataFinal1,
      segmento: segmento,
    })
  },
}
